import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import ReactDOM from "react-dom/client";
import BaseQrTemplate from "./templates/BaseQrTemplate";
import React from "react";

/**
 * PURE PDF GENERATOR
 * No hooks, no state, no side effects outside this function
 */
export async function generateQrPdf({
  units,                 // ✅ NEW
  rooms,                 // ✅ fallback (do not remove)
  unitLabel = "Room",    // ✅ NEW
  unitParam = "room",    // ✅ NEW
  hotelName,
  logo,
  slug,
  bgColor,
  textColor,
}) {
  // 🔒 Normalize once (CRITICAL)
  const finalUnits = units ?? rooms ?? [];

  // 4×6 inch in POINTS (72 DPI)
  const PAGE_WIDTH = 595;   // A4 width
  const PAGE_HEIGHT = 842; // A4 height

  const CARD_WIDTH = 288;
  const CARD_HEIGHT = 420;

  const BORDER_PADDING = 1;
  const BORDER_RADIUS = 12;

  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "pt",
    format: [PAGE_WIDTH, PAGE_HEIGHT],
  });

  // Offscreen container
  const container = document.createElement("div");
  container.style.position = "fixed";
  container.style.left = "-9999px";
  container.style.top = "0";
  document.body.appendChild(container);

  for (let i = 0; i < finalUnits.length; i += 2) {
    if (i !== 0) pdf.addPage();

    for (let slot = 0; slot < 2; slot++) {
      const unit = finalUnits[i + slot];
      if (unit === undefined) break;

      container.innerHTML = "";

      const qrValue =
        unit === 0
          ? `https://zafflo.com/menu/${slug}`
          : `https://zafflo.com/menu/${slug}?${unitParam}=${unit}`;

      const root = ReactDOM.createRoot(container);
      root.render(
        <BaseQrTemplate
          hotelName={hotelName}
          logo={logo}
          unitLabel={unitLabel}                 // ✅ NEW
          unitNumber={unit}                     // ✅ NEW
          qrValue={
            unit === 0
              ? `https://zafflo.com/menu/${slug}`
              : `https://zafflo.com/menu/${slug}?${unitParam}=${unit}`
          }
          bgColor={bgColor}
          textColor={textColor}
        />
      );

      await new Promise((r) => setTimeout(r, 300));

      const element = container.firstElementChild;

      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        backgroundColor: bgColor,
      });

      const imgData = canvas.toDataURL("image/png");

      const x = (PAGE_WIDTH - CARD_WIDTH) / 2;
      const y = slot === 0 ? 0 : CARD_HEIGHT;

      const borderX = x - BORDER_PADDING;
      const borderY = y - BORDER_PADDING;
      const borderW = CARD_WIDTH + BORDER_PADDING * 2;
      const borderH = CARD_HEIGHT + BORDER_PADDING * 2;

      pdf.setDrawColor(0);
      pdf.setLineWidth(1);
      pdf.setLineDash([4, 4]);

      pdf.roundedRect(
        borderX,
        borderY,
        borderW,
        borderH,
        BORDER_RADIUS,
        BORDER_RADIUS
      );

      pdf.setLineDash([]);

      pdf.addImage(
        imgData,
        "PNG",
        x,
        y,
        CARD_WIDTH,
        CARD_HEIGHT,
        undefined,
        "FAST"
      );

      root.unmount();
    }
  }

  document.body.removeChild(container);

  pdf.save(`${slug}-qr-codes.pdf`);
}
